
  import React from "react"
  import Component from "/Users/akil/Documents/Workspace/GitLabRunner/builds/504aade2/0/game-ubg/ubg_client/builds/9f581669/0/project-websites/agamecompany/src/layouts/index.js"
  import data from "/Users/akil/Documents/Workspace/GitLabRunner/builds/504aade2/0/game-ubg/ubg_client/builds/9f581669/0/project-websites/agamecompany/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js